<template>
  <img ref="img">
</template>
<script>
export default {
  props:{
      src:{
          type: String,
          default:''
      }
  },
  watch:{
      src:{
          handler(n){
              if(n){
                  this.getImage(n);
              }
          },
          immediate:true
      }
  },
  methods:{
      getImage(url){
          let that = this;
          that.$nextTick(()=>{
              let request = new XMLHttpRequest();
              request.responseType = 'blob';
              request.open('get', url, true);
              // 添加自定义请求头
              request.setRequestHeader('X-Access-Token', localStorage.getItem('token')); 
              request.onreadystatechange = e => {
                  if (request.readyState == XMLHttpRequest.DONE && request.status == 200) { 
                      that.$refs.img.src = URL.createObjectURL(request.response);
                      that.$refs.img.onload = () => {
                          that.$refs.img && URL.revokeObjectURL(that.$refs.img.src);
                      } 
                  }
              };
              request.send(null);
          });
      }
  }
}
</script>
